import React ,{ useCallback ,useContext, useEffect, useState } from 'react'
import { t } from "i18next";
import { Checkbox, DefaultButton, PrimaryButton, TextField, ChoiceGroup, Dropdown, Toggle  } from "@fluentui/react";
import { studylistDateSearchFilter, viewerForNonXRAYOptions } from '../../User/helpers/CheckboxOptions';
import {
  saveUserPreference
} from "../../../service/UserService";
import loaderContext from '../../../context/loader/LoaderContext';
import toastContext from '../../../context/toast/ToastContext';
import { ACTIONS, AuthRoutes, TOAST_TYPE, USERTYPES } from '../../../constants/Constants';
import userContext from '../../../context/users/UserContext';
import { useNavigate } from 'react-router-dom';
import themeContext from "../../../context/theme/ThemeContext";

const choiceGroupStyles = {
  label: {
    display: "inline",
  },
  flexContainer: {
    columnGap: "1em",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

const PreferenceSettings = (props) => {
  const { theme, themeName } = useContext(themeContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const {isActiveData, setIsActiveData} = useContext(userContext);
  const [activeDataValue, setActiveDataValue] = useState(process.env.REACT_APP_PARTITION_MODE == "false" ? true : props.preferenceData?.user?.activeData != null ? props.preferenceData?.user?.activeData : true);
  const navigate = useNavigate();

  const [prefetchCount, setPrefetchCount] = useState(props.preferenceData.prefetchCount);
  const [errorMessage, setErrorMessage] = useState("");

  const [prefetchEntireStudy, setPrefetchEntireStudy] = useState(props.preferenceData.prefetchCount == -1 ? true : false);
  const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(props.preferenceData?.twoMonitorEnabled || false);

  const handleTwoMonitorChange = (event, checked) => {
    setTwoMonitorEnabled(checked);
  };

  useEffect(() => {
    setTwoMonitorEnabled(props.preferenceData?.twoMonitorEnabled || false);
  }, [props.preferenceData]);

  const setAdvanceViewer = useCallback((e, option) => {
    // console.log(option);
    if(option.key === 1) {
      // console.log(option.key);
      props.preferenceData.nonXrayAdvanceViewer = false;
    } else if(option.key  === 2) {
      // console.log(option.key);
      props.preferenceData.nonXrayAdvanceViewer = true;
      // props.preferenceData.newBasicViewer = true;
    } 
    // else {
    //   // console.log(option.key);
    //   props.preferenceData.nonXrayAdvanceViewer = true;
    //   props.preferenceData.newBasicViewer = false;
    // }
    // props.preferenceData.nonXrayAdvanceViewer = option.key === "true" ? true : false;
  });

  const onToggleChange = (event, checked) => {
    setActiveDataValue(checked);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setPrefetchCount(value);
    
    if (value === '' || (!isNaN(value) && parseInt(value, 10) > 0 && parseInt(value, 10) < 10000)) {
      setErrorMessage(''); 
    } else {
      setErrorMessage(t("Input must be between 1 to 10,000."));
    }
};



  const handleSubmitClick = async()=>{
    if((props.loggedInUserRole !== USERTYPES.FIRMTECHNICIAN && props.loggedInUserRole !== USERTYPES.TYPIST) && !prefetchEntireStudy){
      if (prefetchCount == undefined || prefetchCount == '') {
        setErrorMessage(t("Autoload Count cannot be blank."));
        return;
      }else if (!prefetchEntireStudy && (parseInt(prefetchCount, 10) <= 0 || parseInt(prefetchCount, 10) > 10000)) {
        setErrorMessage(t("Input must be between 1 to 10,000."));
        return;
      }
    }

    setLoaderRunning(true);
    ref.current.continuousStart()
  

    const response = await saveUserPreference(
      props.preferenceData.outline,
      props.preferenceData.heatMap,
      props.preferenceData.nonXrayAdvanceViewer,
      props.preferenceData.newBasicViewer,
      props.preferenceData.studylistSearchDateFilter,
      activeDataValue,
      prefetchEntireStudy ? -1 : prefetchCount,
      props.preferenceData.twoMonitorEnabled = twoMonitorEnabled
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setIsActiveData(process.env.REACT_APP_PARTITION_MODE == "false" ? true : activeDataValue);
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.SUCCESS, "User preference saved successfully")
      if (process.env.REACT_APP_PARTITION_MODE == "true" && isActiveData != activeDataValue)
        navigate(AuthRoutes.STUDYLIST);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while saving user preference")
    }
  }

  const setStudyListDateSearchFilter = useCallback((e, option) => {
    if(option.key === 1) {
      props.preferenceData.studylistSearchDateFilter = 1;
    } else if(option.key  === 2) {
      props.preferenceData.studylistSearchDateFilter = 2;
    } 
  });

  return (
    <div className="tab-section">
      <section className="sectionA">
        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            padding: "0px 0px",
            marginBottom:"28px"
          }}
        >
          {t("account-and-settings.viewer-for-non-X-ray-studies")}
        </p>
      </section>
       {props.advViewerUser && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
          <div className="ms-Grid-row">  
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 ">
              <div>
                <ChoiceGroup
                  defaultSelectedKey={
                    props.preferenceData.nonXrayAdvanceViewer ? 2 : 1 
                  }
                  options={viewerForNonXRAYOptions}
                  styles={choiceGroupStyles}
                  onChange={setAdvanceViewer}
                />
              </div>
            </div>
          </div>
        </div>}
      
      {props.loggedInUserRole === USERTYPES.RADIOLOGIST && <>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              <p><b>{t("account-and-settings.default-ai-representation")}</b></p>
            </div>
          </div>
          <div className="ms-Grid-row">  
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.outline")}
                defaultChecked={props.preferenceData.outline}
                value={props.preferenceData.outline}
                onChange={() => {
                  props.preferenceData.outline = !props.preferenceData.outline;
                }}
              />                  
            </div>
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.heatmap")}
                defaultChecked={props.preferenceData.heatMap}
                value={props.preferenceData.heatMap}
                onChange={() => {
                  props.preferenceData.heatMap = !props.preferenceData.heatMap;
                }}
              />                   
            </div>
          </div>
        </div>
        {process.env.REACT_APP_VDC_PLATFORM === "true" && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              <p><b>Study list Search Date Filter</b></p>
            </div>
        </div>
        <div className="ms-Grid-row">  
          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 ">
            <div>
              <ChoiceGroup
                defaultSelectedKey={
                  props.preferenceData.studylistSearchDateFilter
                }
                options={studylistDateSearchFilter}
                styles={choiceGroupStyles}
                onChange={setStudyListDateSearchFilter}
              />
            </div>
          </div>
        </div>
      </div> }
      </>
      }
      {props.weasisViewerUser && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
            {/* <p>Weasis Viewer download link: <a href="https://weasis.org/en/getting-started/download-dicom-viewer/" target='_blank' style={{color : "gray"}}>download</a></p> */}
            <p>Weasis Viewer download link: <a href="https://weasis.org/en/getting-started/download-dicom-viewer/" target='_blank' style={{color : "blue"}}>download</a></p>
            </div>
        </div>
      </div> }

      {props.infinitViewerUser && !props.weasisViewerUser && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              {/* <p>Infinit Viewer download link: <a href="https://pacs.carepointhealth.com/InstallStarter.msi" target='_blank' style={{color : "gray"}}>download</a></p> */}
              <p>Infinit Viewer download link: <a href="https://pacs.carepointhealth.com/InstallStarter.msi" target='_blank' style={{color : "blue"}}>download</a></p>
              </div>
        </div>
      </div> }

      

 {(props.loggedInUserRole !== USERTYPES.FIRMTECHNICIAN && props.loggedInUserRole !== USERTYPES.TYPIST) && 
  <>
    <div className="ms-Grid-row single-line-form-field">
      <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p className="single-line-form-field-key" style={{ width: '250px' }}>
            {t("account-and-settings.prefetch-entire-study")}
          </p>
          <div className="checkbox-container" style={{ width: '24px' }}>
            <Checkbox
              defaultChecked={prefetchEntireStudy}
              value={prefetchEntireStudy}
              styles={choiceGroupStyles}
              onChange={(e, checked) => {
                setPrefetchEntireStudy(checked);
                if(prefetchCount == -1)
                  setPrefetchCount(50);
              }}
            />
          </div>
        </div>
          <p style={{ fontSize: '13px', color: themeName === "light" ? "#808080" : "#bebebe", marginLeft: '0px' }}>
            {t("account-and-settings.prefetch-entire-study-note")}
          </p>
      </div>
    </div>

    {!prefetchEntireStudy && (
      <div className="ms-Grid-row single-line-form-field">
              <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
                <div style={{display: "flex", alignItems: "center"}}>
                <p className="single-line-form-field-key" style={{ width: "250px" }}>
                  {t("account-and-settings.prefetch-count")}
                      <span
                        style={{
                          position: "absolute",
                          top: "10px",
                          marginLeft: "2px",
                          color: "rgb(164, 38, 44)",
                          fontSize: "small",
                        }}
                      >
                        *
                      </span>
                      </p>
                      <div style={{ width: "100px" }}>
                        <TextField
                          className={"form-field ms-sm12 ms-md8 ms-lg4 ms-xl12"}
                          name="prefetch"
                          placeholder={t("account-and-settings.prefetch-count")}
                          type="number"
                          defaultValue={50}
                          value={prefetchCount}
                          onChange={handleChange}
                          //errorMessage={errorMessage}
                        />
                      </div>
                      </div>
                      {/* Error Message Below the Input Field */}
                      {errorMessage && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "-10px",
                            marginLeft: "252px",
                            fontWeight: "700",
                          }}
                        >
                          {errorMessage}
                        </div>
                      )}
                      <p style={{ fontSize: "13px", color: themeName === "light" ? "#808080" : "#bebebe" }}>
                      {t("account-and-settings.autoload-note")}
                    </p>
                  </div>
                  </div>
            )}

          </>
      }
      <div className="ms-Grid-row single-line-form-field">
        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p className="single-line-form-field-key" style={{ width: '250px' }}>
              {t("account-and-settings.two-monitor-requirement")}
            </p>
            <div className="checkbox-container" style={{ width: '24px' }}>
              <Checkbox
                defaultChecked={twoMonitorEnabled}
                value={twoMonitorEnabled}
                onChange={handleTwoMonitorChange}
              />
            </div>
          </div>
          {/* <p style={{ fontSize: '13px', color: '#bebebe', marginLeft: '0px' }}> */}
          <p style={{ fontSize: '13px', color: themeName === "light" ? "#808080" : "#bebebe", marginLeft: '0px' }}>
            {t("account-and-settings.two-monitor-requirement-note1")}
          </p>
        </div>
      </div>
      <div className="left-side-button-container">
        <PrimaryButton
          style={{
            background: "#2F80ED",
            borderRadius: "5px",
          }}
          text={t("button.save")}
          onClick={handleSubmitClick}
        />
      </div>


      
      
    </div>
  )
}

export default PreferenceSettings